import './styles/static-faq.scss';

type Props = {
  faq: Faq[]
}

type Faq = {
  answer: string
  question: string
}

const Faqs = ({ faq }:Props) => {
  return (
    <section
      className="static-faq-section box"
      data-section="footer faq section"
    >
      <h2 className="title is-size-4 has-text-centered">
        Frequently Asked Questions
      </h2>
      <ul>
        {Object.values(faq).map((dialogue, index) => {
          return (
            <li key={ index }>
              <h3 className="is-size-6">{dialogue.question}</h3>
              <p
                className="fadein is-size-6"
                dangerouslySetInnerHTML={ { __html: dialogue.answer } }
              />
            </li>
          );
        })}
      </ul>
    </section>
  );
};

export default Faqs;